import script from "./TestIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./TestIndex.vue?vue&type=script&setup=true&lang=js"

import "./TestIndex.vue?vue&type=style&index=0&id=6837ca86&lang=css"

const __exports__ = script;

export default __exports__